import { isValidDecimalNumber, noZeroAfterDecimal } from 'utils/isValidDecimalNumber'

const SCORE_PRECISION = 10

// The score is a proportion, so it cannot go above 1.0.
export const IRREPLACEABILITY_SCORE_MAX = 1
export const IRREPLACEABILITY_SCORE_MAX_MESSAGE = 'Please enter a number that does not exceed 1.0'

export const isValidIrreplaceabilityScore = (value) => {
  return isValidDecimalNumber(Number(value))
}

// An empty value is handled by the existing "please complete this field" validation, so it never
// reports as exceeding the maximum here.
export const exceedsIrreplaceabilityScoreMax = (value) => {
  if (value === null || value === undefined || value === '') {
    return false
  }

  return Number.isFinite(Number(value)) && Number(value) > IRREPLACEABILITY_SCORE_MAX
}

export const isWholeNumber = (value) => Number(value) % 1 === 0

export const isValidDecimalWithNoTrailingZero = (value) => noZeroAfterDecimal(value)

export const toCriterionEScore = (value) => Number(Number.parseFloat(value).toFixed(SCORE_PRECISION))

export const isValidYearInput = (value, inputLength) => {
  return new RegExp(`^\\d{0,${inputLength}}$`).test(value)
}

export const isFutureYear = (value) => {
  if (!value) return false
  return Number(value) > new Date().getFullYear()
}

